{
    "ErrorMessage": "Não foi possível carregar o arquivo de áudio.",
    "NAME": "MediaPlayer"
}